export default __webpack_public_path__ + "static/media/icon-bag.42ee0ade.svg";